<template>
  <div>
    <div
      v-if="!shouldHideTitle"
      class="image-title"
    >
      {{ title }}
    </div>
    <div
      ref="fileform"
      class="image-wrapper"
    >
      <div
        v-if="isVirtualAsset || (!isVirtualAsset && preview)"
        :class="imagePreviewClasses"
        :style="source.styles ? source.styles : {}"
      >
        <div
          :class="imageOverlayClasses"
        >
          <button
            v-if="isImageEditable"
            class="change-image-button"
            @click="handleChangeImageStart"
          >
            Change Image
          </button>
          <button
            v-if="proccessStage === STAGES.UPLOAD"
            class="change-image-button"
            @click="handleChangeImageCancel"
          >
            Cancel
          </button>

          <Button
            v-if="
              proccessStage === STAGES.UPLOAD_ERROR
                || proccessStage === STAGES.AFTER_LOAD_VALIDATION_ERROR"
            title="Clear"
            classType="warning"
            :eventFunction="handleChangeImageClear"
          />

          <Button
            v-if="proccessStage === STAGES.AFTER_LOAD_VALIDATION_SUCCESS"
            title="Cancel"
            classType="warning"
            :eventFunction="handleChangeImageCancel"
          />
          <Button
            v-if="proccessStage === STAGES.AFTER_LOAD_VALIDATION_SUCCESS"
            title="Apply"
            classType="primary"
            :eventFunction="handleChangeImageApply"
          />

          <div
            v-if="(proccessStage === STAGES.UPLOAD || proccessStage === STAGES.EMPTY)
              && source.canEdit"
            class="file-form"
            @click="onFileInput"
          >
            <div class="drag-zone">
              <inline-svg
                :src="iconUpload"
                class="svg"
              />
              <span class="drop-files">
                Drag & Drop
              </span>
              <span class="drop-files">
                or click to <span class="browser-link">browse</span>
              </span>
            </div>
          </div>
        </div>
        <img
          ref="preview"
          :src="preview"
          :alt="fileName"
          :class="imageClasses"
        />
      </div>
      <input
        ref="fileInput"
        type="file"
        class="input-hidden"
        :accept="!isImagesOnly ? 'image/x-png,image/webp,image/jpeg' : 'image/x-png,image/jpeg'"
        @change="fileInputChange"
      />
      <span
        v-if="
          proccessStage === STAGES.AFTER_LOAD_VALIDATION_ERROR
            || proccessStage === STAGES.UPLOAD_ERROR
        "
        class="error-label"
      >
        {{ validationMessage }}
      </span>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import iconUpload from '../../../assets/icons/icon-upload.svg';
import Button from '../Button.vue';
import {
  EDIT_MEZZ_IMAGE_ASSET_REQUEST,
  EDIT_POSTER_ASSET_REQUEST,
} from '../../../store/actions/media/mediaAsset';

export default {
  name: 'AssetPosterImageUploader',
  components: {
    Button,
  },
  props: {
    isHDPoster: {
      type: Boolean,
      default: false,
    },
    is4kPoster: {
      type: Boolean,
      default: false,
    },
    is4kMobileBannerImage: {
      type: Boolean,
      default: false,
    },
    shouldHideTitle: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Object,
      default: () => ({}),
      required: true,
    },
    addAssetItemWithChanges: {
      type: Function,
      default: () => {},
    },
    removeAssetItemWithChanges: {
      type: Function,
      default: () => {},
    },
    getMediaItemAssets: {
      type: Function,
      default: () => {},
    },
    setAssetIsInProcessing: {
      type: Function,
      default: () => {},
    },
    isVirtualAsset: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      aspectRatio: 16 / 9,
      iconUpload,
      dragAndDropCapable: false,
      file: null,
      preview: '',
      validationMessage: '',
      fileName: '',
      isImagesOnly: false,
      proccessStage: '',
      STAGES: {
        EMPTY: 'empty',
        READY: 'ready',
        UPLOAD: 'upload',
        UPLOAD_ERROR: 'uploadError',
        AFTER_LOAD_VALIDATION: 'afterLoadValidation',
        AFTER_LOAD_VALIDATION_SUCCESS: 'afterLoadValidationSuccess',
        AFTER_LOAD_VALIDATION_ERROR: 'afterLoadValidationError',
        DONE: 'done',
        ERROR: 'error',
      },
      hasChanges: false,
    };
  },
  computed: {
    ...mapState({
      mediaItem: (state) => state.mediaItem.mediaItem,
    }),
    ...mapGetters([
      'getCurrentAccountId',
      'isContributor',
    ]),
    sourceRatio() {
      if (!this.source || !this.source.dimensions) {
        return 1;
      }
      const [w, h] = this.source.dimensions.split('x');
      return w / h;
    },
    isSourceVertical() {
      return this.sourceRatio < 1;
    },
    isSourceHorizontal() {
      return this.sourceRatio > 1;
    },
    title() {
      return this.source.assetRole?.name || 'Image';
    },
    isPoster2x3() {
      return this.source.entityType === 'supplemental file'
        && this.source.assetRole
        && this.source.assetRole.shortName === 'posterImage2x3'
        && this.source.type === 'image'
        && this.source.isAnyPoster;
    },
    isPoster9x16() {
      return this.source.entityType === 'supplemental file'
        && this.source.assetRole
        && this.source.assetRole.shortName === 'posterImage9x16'
        && this.source.type === 'image'
        && this.source.isAnyPoster;
    },
    imageClasses() {
      return {
        image: true,
        'image-horizontal': this.isSourceHorizontal,
        'image-vertical ': this.isSourceVertical,
      };
    },
    imageOverlayClasses() {
      return {
        'image-overlay': true,
        'image-iverlay-changing': this.proccessStage === this.STAGES.UPLOAD
          || this.proccessStage === this.STAGES.AFTER_LOAD_VALIDATION
          || this.proccessStage === this.STAGES.AFTER_LOAD_VALIDATION_ERROR
          || this.proccessStage === this.STAGES.EMPTY,
        'image-iverlay-valid': this.proccessStage === this.STAGES.AFTER_LOAD_VALIDATION_SUCCESS,
      };
    },
    imagePreviewClasses() {
      return {
        'image-preview': true,
        'image-preview-error': this.proccessStage === this.STAGES.UPLOAD_ERROR || this.proccessStage === this.STAGES.AFTER_LOAD_VALIDATION_ERROR,
      };
    },
    isImageEditable() {
      return this.source.canEdit
        && !this.source.canDelete
        && this.proccessStage === this.STAGES.READY
        && !(this.isContributor && (this.mediaItem.approved || this.mediaItem.locked));
    },
  },
  watch: {
    hasChanges(newVal) {
      if (newVal) {
        this.addAssetItemWithChanges(this.source.id);
      } else {
        this.removeAssetItemWithChanges(this.source.id);
      }
    },
  },
  mounted() {
    if (!this.source.url) {
      this.proccessStage = this.STAGES.EMPTY;
    } else {
      this.proccessStage = this.STAGES.READY;
    }

    this.dragInit();
    this.preview = this.source.url || '';
    this.file = this.source.url || '';
    this.fileName = this.source.name || '';
  },
  methods: {
    startProcessing() {
      this.setAssetIsInProcessing(this.source.id);
    },
    stopProcessing() {
      this.setAssetIsInProcessing(null);
    },
    dragInit() {
      if (!this.isImageEditable) {
        return;
      }
      this.dragAndDropCapable = this.determineDragAndDropCapable();
      if (this.dragAndDropCapable) {
        ['drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop'].forEach((evt) => {
          this.$refs.fileform?.addEventListener(evt, (e) => {
            e.preventDefault();
            e.stopPropagation();
          }, false);
        });

        this.$refs.fileform?.addEventListener('drop', this.dropHandle);
      }
    },
    dropHandle(e) {
      this.file = e.dataTransfer.files[0];
      this.fileName = this.file.name;
      this.getImagePreviews(this.file);
    },
    determineDragAndDropCapable() {
      const div = document.createElement('div');
      return (('draggable' in div)
        || ('ondragstart' in div && 'ondrop' in div))
        && 'FormData' in window
        && 'FileReader' in window;
    },
    getImagePreviews(file) {
      if (this.validateFile(file)) {
        this.proccessStage = this.STAGES.AFTER_LOAD_VALIDATION;
        this.validationMessage = '';
        const reader = new FileReader();
        reader.addEventListener('load', () => {
          this.afterLoadValidation(reader.result).then((isValid) => {
            if (isValid) {
              this.hasChanges = true;
              this.preview = reader.result;
              this.proccessStage = this.STAGES.AFTER_LOAD_VALIDATION_SUCCESS;
            } else {
              this.proccessStage = this.STAGES.AFTER_LOAD_VALIDATION_ERROR;
            }
          }).catch(() => {
            this.proccessStage = this.STAGES.AFTER_LOAD_VALIDATION_ERROR;
          });
        }, false);
        reader.readAsDataURL(file);
      } else {
        this.proccessStage = this.STAGES.UPLOAD_ERROR;
      }
    },
    validateFile(file) {
      if (!this.isImagesOnly && !(/\.(jpe?g|png)$/i.test(file.name))) {
        this.validationMessage = 'File MIME type should be PNG or JPEG';
        return false;
      }

      if (this.isImagesOnly && !(/\.(jpe?g|png)$/i.test(file.name))) {
        this.validationMessage = 'File MIME type should be PNG or JPEG';
        return false;
      }

      if (((file.size / 1024) / 1024) > 10) {
        this.validationMessage = 'File size can be no more than 10 MB';
        return false;
      }

      return true;
    },
    afterLoadValidation(src) {
      return new Promise((resolve) => {
        let isError = false;
        const minAspect = (parseFloat(this.aspectRatio.toFixed(2)) - parseFloat(0.1)).toFixed(2);
        const maxAspect = (parseFloat(this.aspectRatio.toFixed(2)) + parseFloat(0.1)).toFixed(2);

        const img = new Image();
        img.src = src;
        img.onload = () => {
          if (this.isPoster2x3) {
            this.aspectRatio = 2 / 3;
            const minAspect = (parseFloat(this.aspectRatio.toFixed(2)) - parseFloat(0.1))
              .toFixed(2);
            const maxAspect = (parseFloat(this.aspectRatio.toFixed(2)) + parseFloat(0.1))
              .toFixed(2);
            const aspect = (img.width / img.height).toFixed(2);
            if (img.height < 1080) {
              isError = true;
              this.validationMessage = 'Min height should be 1080px';
            }
            if (aspect < minAspect || aspect > maxAspect) {
              isError = true;
              this.validationMessage = 'Aspect Ratio should be 2:3';
            } else {
              isError = false;
            }

            resolve(!isError);
            return;
          }

          if (!this.isImagesOnly) {
            const aspect = (img.width / img.height).toFixed(2);

            if (this.is4kMobileBannerImage) {
              if (+aspect !== 3) {
                isError = true;
                this.validationMessage = 'Aspect Ratio should be 3:1';
                resolve(!isError);
                return;
              }

              if (img.height < 480) {
                isError = true;
                this.validationMessage = 'Min height should be 480px';
                resolve(!isError);
                return;
              }

              isError = false;
            }

            if (this.isPoster9x16) {
              const aspectRatio9x16 = 9 / 16;
              const minAspect9x16 = (parseFloat(aspectRatio9x16.toFixed(2)) - parseFloat(0.1))
                .toFixed(2);
              const maxAspect9x16 = (parseFloat(aspectRatio9x16.toFixed(2)) + parseFloat(0.1))
                .toFixed(2);

              if (aspect < minAspect9x16 || aspect > maxAspect9x16) {
                isError = true;
                this.validationMessage = 'Aspect Ratio should be 9:16';
                resolve(!isError);
                return;
              }

              isError = false;
              resolve(!isError);
              return;
            }

            if (!this.is4kPoster && !this.is4kMobileBannerImage && !this.isPoster9x16) {
              if (aspect < minAspect || aspect > maxAspect) {
                isError = true;
                this.validationMessage = 'Aspect Ratio should be 16:9';
                resolve(!isError);
                return;
              }
            } else if (+aspect !== 4) {
              isError = true;
              this.validationMessage = 'Aspect Ratio should be 4:1';
              resolve(!isError);
              return;
            }

            if (this.isHDPoster) {
              if (img.height < 720) {
                isError = true;
                this.validationMessage = 'Min height should be 720px';
              } else {
                isError = false;
              }
            } else if (!this.is4kPoster && img.height < 1080) {
              isError = true;
              this.validationMessage = 'Min height should be 1080px';
            } else if (this.is4kPoster && +aspect === 4 && img.height < 480) {
              isError = true;
              this.validationMessage = 'Min height should be 480px';
            } else {
              isError = false;
            }
          }

          if (this.isImagesOnly) {
            if (img.height < 1400
            || img.height > 3000
            || img.width < 1400
            || img.width > 3000) {
              isError = true;
              this.validationMessage = 'Minimum: 1400 x 1400 pixels.\n'
            + 'Maximum: 3000 x 3000 pixels';
            } else if (this.isImagesOnly && (img.width.toFixed(2) / img.height.toFixed(2) !== 1)) {
              isError = true;
              this.validationMessage = 'Aspect Ratio should be 1:1';
            } else {
              isError = false;
            }
          }

          resolve(!isError);
        };
      });
    },
    fileInputChange() {
      const { files } = this.$refs.fileInput;
      if (files[0]) {
        this.file = files[0];
        this.fileName = this.file.name;
        this.getImagePreviews(this.file);
      }
    },
    onFileInput() {
      this.$refs.fileInput.click();
    },
    handleChangeImageStart() {
      this.proccessStage = this.STAGES.UPLOAD;
    },
    handleChangeImageCancel() {
      this.proccessStage = this.STAGES.READY;
      this.resetForm();
    },
    handleChangeImageClear() {
      this.proccessStage = this.STAGES.UPLOAD;
      this.resetForm();
    },
    resetForm() {
      this.$refs.fileInput.value = '';
      this.file = null;
      this.preview = this.source.url || '';
      this.validationMessage = '';
      this.hasChanges = false;
    },
    handleChangeImageDuringProcessingApply() {
      let type = 'poster';
      if (this.isPoster2x3) {
        type = 'poster-2x3';
      } else if (this.isPoster9x16) {
        type = 'poster-9x16';
      }

      const params = {
        accountId: this.getCurrentAccountId,
        type,
        data: {
          posterImage: this.preview,
          mediaItem: this.mediaItem.id,
        },
      };

      this.$store.dispatch(EDIT_POSTER_ASSET_REQUEST, params)
        .then((res) => {
          this.$toasted.global.success({
            message: 'The Image asset has been successfully updated',
          });

          this.$emit('updateMediaItem', res);
          this.proccessStage = this.STAGES.READY;
          this.hasChanges = false;
        })
        .catch((error) => {
          this.onSubmitFail(error);
          this.proccessStage = this.STAGES.READY;
          this.hasChanges = false;
        })
        .finally(() => {
          this.stopProcessing();
        });
    },
    handleChangeImageApply() {
      if (this.isVirtualAsset) {
        this.startProcessing();
        this.handleChangeImageDuringProcessingApply();
        return;
      }
      this.startProcessing();
      let type = 'poster';
      if (this.isPoster2x3) {
        type = 'poster-2x3';
      } else if (this.isPoster9x16) {
        type = 'poster-9x16';
      }
      const params = {
        accountId: this.getCurrentAccountId,
        audioId: this.source.id,
        type,
        data: {
          assetRole: this.source.assetRole?.id || null,
          posterImage: this.preview,
        },
      };
      this.$store.dispatch(EDIT_MEZZ_IMAGE_ASSET_REQUEST, params)
        .then(() => {
          this.$toasted.global.success({
            message: 'The Image asset has been successfully updated',
          });

          this.getMediaItemAssets(this.mediaItem.id);
          this.proccessStage = this.STAGES.READY;
          this.hasChanges = false;
        })
        .catch((error) => {
          this.onSubmitFail(error);
          this.proccessStage = this.STAGES.READY;
          this.hasChanges = false;
        })
        .finally(() => {
          this.stopProcessing();
        });
    },
    onSubmitFail(error) {
      const imgError = error
        && error.form_errors
        && error.form_errors.children
        && error.form_errors.children.posterImage
        && error.form_errors.children.posterImage.errors
        && error.form_errors.children.posterImage.errors[0].error;

      if (imgError === 'INVALID_MIME_TYPE_ERROR') {
        this.validationMessage = 'File MIME type should be PNG or JPEG';
      }
    },
  },
};
</script>
<style scoped>
  .image-title {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    color: #ffffff;
    margin-bottom: 10px;
  }

  .image-wrapper {
    width: 460px;
    height: 390px;
    position: relative;
  }

  .image-overlay {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    transition: background-color 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .image-iverlay-changing {
    background-color: rgba(0, 0, 0, 0.85);
  }

  .image-iverlay-valid {
    background-color: rgba(0, 0, 0, 0.5);
  }

  .change-image-button {
    position: absolute;
    top: 0px;
    left: 0px;
    height: 40px;
    border: none;
    cursor: pointer;
    color: #ffffff;
    font-size: 14px;
    line-height: 20px;
    font-weight: 600;
    z-index: 1;
    background-color: rgba(0, 0, 0, 0.4);
    padding: 10px 16px;
    border-radius: 0 0 4px 0;
    transition: background-color 0.3s ease;
  }

  .change-image-button:hover {
    background-color: rgba(0, 0, 0, 0.6);
  }

  .image-preview {
    width: fit-content;
    height: fit-content;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    border: 1px dashed #a0a0a0;
  }

  .image-preview-error {
    border-color: #fb3951;
  }

  .image {
    object-fit: cover;
    object-position: center;
  }

  .image-horizontal {
    width: 460px;
    max-width: 100%;
    height: auto;
  }

  .image-vertical {
    width: auto;
    height: 390px;
    max-height: 100%;
  }

  .file-form {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100%;
    cursor: pointer;
  }

  .drag-zone {
    display: flex;
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    align-items: center;
  }

  .browser-link {
    color: rgb(37, 145, 207);
  }

  .input-hidden {
    display: none;
  }
</style>
